import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Index from "./pages/Index.tsx";

const About    = lazy(() => import("./pages/About.tsx"));
const Services = lazy(() => import("./pages/Services.tsx"));
const Projects = lazy(() => import("./pages/Projects.tsx"));
const Contact  = lazy(() => import("./pages/Contact.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const App = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route path="/"         element={<Index />} />
      <Route path="/about"    element={<Suspense fallback={null}><About /></Suspense>} />
      <Route path="/services" element={<Suspense fallback={null}><Services /></Suspense>} />
      <Route path="/projects" element={<Suspense fallback={null}><Projects /></Suspense>} />
      <Route path="/contact"  element={<Suspense fallback={null}><Contact /></Suspense>} />
      <Route path="*"         element={<Suspense fallback={null}><NotFound /></Suspense>} />
    </Routes>
  </BrowserRouter>
);

export default App;
